<template>
  <w-modal
    :value="value"
    :width="448"
    @close="close"
  >
    <template #header>
      <h1>
        全部收款
      </h1>
    </template>
    <template #content>
      <p class="text-black">
        請問是否將所有已訂人員的付款狀態標示為已付清?
      </p>
    </template>
    <template #footer>
      <div class="flex items-center justify-end">
        <w-button
          :disabled="loading"
          class="mr-6"
          type="link"
          @click="close"
        >
          取消
        </w-button>
        <w-button
          :disabled="loading"
          :loading="loading"
          @click="onConfirm"
        >
          確認
        </w-button>
      </div>
    </template>
  </w-modal>
</template>

<script>
import PaidAll from './PaidAll';

export default PaidAll;
</script>

<style lang="scss" scoped>
@import 'PaidAll';
</style>
